import { useTranslation } from 'react-i18next'

import {
  OptionItem,
  OptionResponse,
  TransactionInput,
} from '../../../apis/fvillage'
import { getOptionAnswerGroups } from '../../../utils'
import { Section, Text } from '../../basics'

type OptionAnswersSectionProps = {
  options?: OptionResponse[]
  items?: OptionItem[]
  input?: TransactionInput
}

const translateNamespace = 'components.OptionAnswersSection'

export const OptionAnswersSection: React.FC<OptionAnswersSectionProps> = ({
  options = [],
  items = [],
  input,
}) => {
  const { t, i18n } = useTranslation()
  const groups = getOptionAnswerGroups(i18n.language, options, items, input)

  if (groups.length === 0) {
    return null
  }

  return (
    <Section title={t(`${translateNamespace}.title`)}>
      {groups.map(({ option, name, lines }) => (
        <div key={option}>
          <Text>{name}</Text>
          {lines.map(({ id, label, value }) => (
            <Text key={id}>{`${label}: ${
              value || t(`${translateNamespace}.unanswered`)
            }`}</Text>
          ))}
        </div>
      ))}
    </Section>
  )
}
